// services/user/HomepageUserService.js
import API from "../../api/apiUser"; // same axios instance you already use

const HomepageUserService = {
  getHomepageData() {
    return API.get("/user/homepage", {
      params: {
        popular_limit: 8,
        gallery_limit: 10,
        insights_limit: 3,
      },
    });
  },
};

export default HomepageUserService;
